import React from "react";
import { Box, LinearProgress, linearProgressClasses, useTheme } from "@mui/material";
import { normaliseByMax } from "../functions/normaliseLinearProgress.function";
import { getGradientColor } from "../functions/getGradientColor.function";

interface ProgressBarProps {
  value: number;
  max: number;
}

export const StyledOverflowLinearProgress: React.FC<ProgressBarProps> = ({ value, max }) => {
  const theme = useTheme();
  const bgColorForBar =
    theme.palette.mode === "dark" ? theme.palette.grey[600] : theme.palette.grey[300];

  // normalised value by max value
  const normaliseValue = normaliseByMax(value, max);
  // Custom value exceeding max
  const overage = normaliseValue > 100 ? normaliseValue - 100 : 0;

  return (
    <Box sx={{ width: "100%", position: "relative" }}>
      {/* Primary progress bar */}
      <LinearProgress
        data-testid="primary-progress-bar"
        variant="determinate"
        value={normaliseValue}
        sx={{
          width: "100%",
          height: 10,
          backgroundColor: bgColorForBar,
          [`& .${linearProgressClasses.bar}`]: {
            backgroundColor: getGradientColor(normaliseValue - overage)
          }
        }}
      />

      {/* Secondary progress bar for overage */}
      {overage > 0 && (
        <LinearProgress
          data-testid="overage-progress-bar"
          variant="determinate"
          value={overage}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: `${overage}%`,
            maxWidth: "100%",
            height: 10,
            zIndex: 1,
            [`&.${linearProgressClasses.colorPrimary}`]: {
              backgroundColor: getGradientColor(normaliseValue)
            },
            [`& .${linearProgressClasses.bar}`]: {
              backgroundColor: getGradientColor(normaliseValue)
            }
          }}
        />
      )}
    </Box>
  );
};
